import Linkbar from "../../../shared/components/Linkbar/Linkbar";
import RefillAreasList from "./RefillAreasList";
import { useTranslation } from "@coworker/locales";
import { orderedRefillAreas } from "../../constants/refillAreas";

const RefillAreasView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Linkbar currentLabel={t("refillAreasString")} />
      <RefillAreasList refillAreas={orderedRefillAreas} />
    </>
  );
};

export default RefillAreasView;
